import { SvgIcon } from '../svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from '../svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 256 256',
    defaultAriaLabel: 'Night HME Icon',
};

export const NightHMEIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <circle cx="128.5" cy="128.5" r="90.5" fill="#EAF7FA" />
            <path
                d="M216.5 128.5C216.5 79.8989 177.101 40.5 128.5 40.5C79.8989 40.5 40.5 79.8989 40.5 128.5C40.5 177.101 79.8989 216.5 128.5 216.5C177.101 216.5 216.5 177.101 216.5 128.5ZM221.5 128.5C221.5 179.862 179.862 221.5 128.5 221.5C77.1375 221.5 35.5 179.862 35.5 128.5C35.5 77.1375 77.1375 35.5 128.5 35.5C179.862 35.5 221.5 77.1375 221.5 128.5Z"
                fill="#00A2BA"
            />
            <path
                d="M122.018 64.8398C123.939 64.4968 125.598 65.4406 126.471 66.8008C127.353 68.1746 127.514 70.0721 126.517 71.7021C115.696 89.3811 114.84 112.318 126.237 131.313C137.633 150.31 158.274 160.351 178.966 159.124L179.32 159.115C181.07 159.141 182.521 160.134 183.269 161.47C184.084 162.926 184.113 164.912 182.782 166.47C178.505 171.478 173.359 175.889 167.406 179.46C137.824 197.208 99.4541 187.613 81.7063 158.03C63.9585 128.447 73.5533 90.078 103.136 72.3301C109.088 68.7595 115.4 66.2941 121.83 64.8769L122.018 64.8398ZM121.68 70.0449C116.194 71.3817 110.811 73.5569 105.708 76.6181C78.4935 92.9454 69.6664 128.243 85.9934 155.458C102.321 182.673 137.619 191.499 164.834 175.172C169.938 172.11 174.39 168.382 178.152 164.169C156.048 165.084 134.136 154.201 121.948 133.886C109.761 113.571 110.47 89.1162 121.68 70.0449Z"
                fill="#00A2BA"
            />
        </SvgIcon>
    );
};
